<template>
  <div>
    <el-row style="margin-bottom: 22px">
      <el-input v-model="queryInfo.packMaterialCode" class="query-input" placeholder="包材条码" clearable></el-input>
      <el-select v-model="queryInfo.subClass" placeholder="备件小类" clearable class="query-input" filterable style="margin-left: 10px">
        <el-option v-for="item in subClassList" :key="item.value" :label="item.name" :value="item.value"></el-option>
      </el-select>
      <el-button @click="currentChange(1)" type="primary" :loading="loading" class="query-btn">查询</el-button>
      <el-button type="primary" @click="dialogVisible = true">添加</el-button>
    </el-row>

    <el-table :data="packMaterialSubClassList" border style="width: 100%" stripe>
      <el-table-column align="center" prop="packMaterialCode" label="包材条码"></el-table-column>
      <el-table-column align="center" prop="subClassName" label="小类"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
      <el-table-column align="center" prop="createUserName" label="创建人"></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button @click="deleteData(scope.row)" type="danger" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-box">
      <el-pagination background layout="total,prev, pager, next" :page-size="pageSize" :total="total" @current-change="currentChange" :current-page.sync="queryInfo.pageNo"></el-pagination>
    </div>
    <el-dialog title="添加包材小类" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px" :before-close="handleClose">
      <el-form v-model="formData" label-width="200px">
        <el-form-item label="包材条码：">
          <el-input v-model.trim="formData.packMaterialCode" placeholder="请输入包材条码" class="query-input" clearable></el-input>
        </el-form-item>
        <el-form-item label="备件小类：">
          <el-select v-model="formData.subClass" placeholder="备件小类" clearable class="query-input" filterable>
            <el-option v-for="item in subClassList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="addPackSubClass">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "PackMaterialSubClass",
  data() {
    return {
      queryInfo: {
        packMaterialCode: '',
        subClass: '',
        pageNo: 1
      },
      formData: {
        packMaterialCode: '',
        subClass: '',
      },
      packMaterialSubClassList: [],
      total: 0,
      pageSize: 0,
      dialogVisible: false,
      loading: false
    }
  },
  computed: {
    subClassList() {
      return this.$store.getters.getDictList('subClass') || [];
    }
  },
  created() {
    this.queryList();
  },
  methods: {
    queryList() {
      this.loading = true;
      this.$axios.post('packMaterialSubClass/queryMaterial', this.queryInfo).then(response => {
        this.loading = false;
        let res = response.data;
        if (res.code !== 0) {
          return this.$message.error(res.message);
        }

        this.packMaterialSubClassList = res.data.records;
        this.total = res.data.total;
        this.pageSize = res.data.size;
      }, error => {
        this.loading = false;
        return this.$message.error('查询失败，' + error.message);
      });
    },
    currentChange(pageNo) {
      this.queryInfo.pageNo = pageNo;
      this.queryList()
    },
    handleClose() {
      this.dialogVisible = false;
    },
    async addPackSubClass() {
      if (!this.formData.packMaterialCode) {
        return this.$message.error('包材条码不能为空');
      }
      if (!this.formData.subClass) {
        return this.$message.error('备件小类不能为空');
      }

      const {data: res} = await this.$axios.post('packMaterialSubClass/add', this.formData);
      if (res.code !== 0) {
        return this.$message.error(res.message);
      }
      this.$message.success("添加成功");
      this.queryList();
      this.handleClose()
      this.formData.packMaterialCode = ''
      this.formData.subClass = ''
    },
    deleteData(row) {
      this.$confirm('确定删除吗？', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning',
      }).then(() => {
        this.$axios.post('packMaterialSubClass/delete', row.id).then(response => {
          if (response.data.code !== 0) {
            return this.$message.error(response.data.message);
          }
          this.$message.success("删除成功");
          this.queryList();
        })
      })
    },
  }
}
</script>

<style scoped>
.query-input {
  width: 250px;
}

.query-btn {
  margin-left: 10px;
}
</style>